import React, {Component} from "react";
import {connect} from 'react-redux';
import {Loader} from "../../../../../common/elements";
import {CourseOverview, CourseInfo, CourseSlider} from "./elements";
import {PrismicDocumentHelper, PrismicSliceDataHelper} from "../../../../../../helpers/prismicHelpers/PrismicHelpers";
import {courseListHelper} from "../../../../../../helpers/prismicHelpers/prismic-custom-helpers/CourseHelpers";
import BreakBanner from "../../../../../dashboardNew/components/BreakBanner";
import BackButton from "../../../../../dashboardNew/components/tools/BackButton";
import * as todoListActions from '../../../../../../../client/actions/todo_list/todo_list';


class CourseItemFull extends Component {
    constructor() {
        super();
        this.state = {
            course: [],
            modules: [],
            current: [],
            data: '',
            isModule: false
        };

        this.getCurrentCourse = this.getCurrentCourse.bind(this);
        this.updateModule = this.updateModule.bind(this);
    }

    componentDidMount() {
        const personId = localStorage.getItem("person_id");
        const {updateTodoList} = this.props;

        setTimeout(() => updateTodoList(personId, 1), 120000);
    }

    componentWillMount() {
        const {courseId} = this.props.params;

        this.getCurrentCourse(courseId);
    }

    async getCurrentCourse(id) {
        try {
            const data = await PrismicDocumentHelper('document.id', id, false, 'at')
            let courseData = courseListHelper(data);
            let slices = await PrismicSliceDataHelper(data);

            this.setState({course: courseData, modules: slices});
        } catch (err) {
            return {error: true};
        }
    }

    updateModule = (moduleData) => {
        this.setState({current: moduleData, isModule: true});
    }

    CPDModule(showCPD) {
        if(showCPD === 'show'){
        return (
            <div className='col-12 cpd-wrapper'>
                <img className="cpd-img" src="/images/CPD.png" alt="CPD logo"/>
                <h4 className='cpd-copy heading-two'>This course is <br />CPD accredited</h4>
            </div>
        )
        }
    }

    render() {
        const courseId = this.props.params;
        const courseTitle = this.state.course[0];
        const showCPD = this.state.course[0] && this.state.course[0].show_cpd;
        if (
            !this.props.params.courseId ||
            !Array.isArray(this.state.course) ||
            !this.state.course.length
        ) {
            return <Loader/>;
        }

        return (
            <article className="container-fluid courses-page">
                <div className="container">
                    <div className="row">
                        <div className="col-12 courses-link">
                            <BackButton
                                title="On-Demand"
                                path="/training/courses"
                            />
                            <h1 className="heading-main">{courseTitle.name}</h1>
                            <p className="body-copy">{courseTitle.description}</p>
                        </div>
                        <div className="wista-video-wrapper">
                            <div className="video-inner">
                                <CourseInfo course={!this.state.isModule ? this.state.course : this.state.current}/>
                                <CourseSlider
                                    updateModule={this.updateModule}
                                    modules={this.state.modules}
                                    params={courseId}
                                    current={this.state.current}
                                    courseTitle={courseTitle}
                                />
                            </div>
                        </div>
                        <CourseOverview course={!this.state.isModule ? this.state.course : this.state.current}/>
                         {showCPD && this.CPDModule(showCPD)}
                    </div>
                </div>
                <BreakBanner
                    title="Want to find out more"
                    copy="Get in touch and lets start improving your chances to get a job"
                    cta_text="Contact us"
                    cta_link="/contact-us"
                />
            </article>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
      updateTodoList: (personId, listItem) => dispatch(todoListActions.updateTodoList(personId, listItem))
    }
  };

  export default connect(null, mapDispatchToProps)(CourseItemFull);
  


// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/CourseFullView.js